export const CalendarIcon = () => {
  return (
    <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
      <mask
        height="32"
        id="mask0_10918_29452"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="32"
        x="0"
        y="0"
      >
        <rect fill="#D9D9D9" height="32" width="32" />
      </mask>
      <g mask="url(#mask0_10918_29452)">
        <path
          d="M19.2597 24.4386C18.347 24.4386 17.5755 24.1189 16.9453 23.4794C16.3151 22.8399 16 22.0571 16 21.1309C16 20.2047 16.3151 19.4219 16.9453 18.7824C17.5755 18.1429 18.347 17.8231 19.2597 17.8231C20.1724 17.8231 20.9439 18.1429 21.5741 18.7824C22.2043 19.4219 22.5194 20.2047 22.5194 21.1309C22.5194 22.0571 22.2043 22.8399 21.5741 23.4794C20.9439 24.1189 20.1724 24.4386 19.2597 24.4386ZM6.96634 30C6.14533 30 5.44568 29.7066 4.86741 29.1198C4.28914 28.533 4 27.823 4 26.9899V8.65629C4 7.82317 4.28914 7.11321 4.86741 6.52641C5.44568 5.93961 6.14533 5.64622 6.96634 5.64622H8.17668V4.4101C8.17668 4.01405 8.31206 3.68008 8.58284 3.40818C8.85339 3.13606 9.18382 3 9.57412 3C9.96442 3 10.2935 3.13606 10.5615 3.40818C10.8297 3.68008 10.9637 4.01405 10.9637 4.4101V5.64622H21.0363V4.4101C21.0363 4.01405 21.1717 3.68008 21.4424 3.40818C21.713 3.13606 22.0434 3 22.4337 3C22.824 3 23.1531 3.13606 23.4211 3.40818C23.6892 3.68008 23.8233 4.01405 23.8233 4.4101V5.64622H25.0337C25.8547 5.64622 26.5543 5.93961 27.1326 6.52641C27.7109 7.11321 28 7.82317 28 8.65629V26.9899C28 27.823 27.7109 28.533 27.1326 29.1198C26.5543 29.7066 25.8547 30 25.0337 30H6.96634ZM6.96634 26.9899H25.0337V13.8538H6.96634V26.9899Z"
          fill="#139E60"
        />
      </g>
    </svg>
  );
};
